export default "__VITE_ASSET__B2UPC9iX__"